<template>
  <div>
    <nav-top />
    <div class="container-fluid">
      <div class="row flex-xl-nowrap">
        <main class="p-3 col-12" role="main">
          <slot></slot>
        </main>
      </div>
    </div>
    <hr />
    <pre class="text-right text-muted px-4">v{{ version }}</pre>
  </div>
</template>

<script setup>
import { ref } from 'vue'
import NavTop from '@/components/navigation/nav-top'

const version = ref(window.config?.version || '')
</script>
